import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import ProductDesignAndDevelopment from 'views/productDesignAndDevelopment';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import Layout from 'components/layout';
import config from '../../meta/config';

class PDADPage extends Component {
  render() {
    const page = pages['product-design-and-development'];
    const { navColors } = page;
    const canonical = `${config.siteUrl}/product-design-and-development/`;

    const { data } = this.props;
    const { allArticles } = data || {};

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Product Design and Development">
          <meta
            name={'description'}
            content={
              'Design and develop an innovative user-centred digital product and release it to market.'
            }
          />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar color={navColors} />
        <PopupRedirect />
        <ProductDesignAndDevelopment allArticles={allArticles} />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query PDADQuery {
    allArticles: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          title: {
            in: [
              "How to deliver an e-commerce platform MVP in just 6 weeks"
              "Visualising Energy"
              "How to scale a monolithic MVP application without losing business?"
              "From design to development in 4 weeks. Creating a mobile and web MVP for an iconic brand"
              "Designing a simple search experience for a complex product with a luxurious interface"
            ]
          }
        }
      }
    ) {
      ...markdownFields
      ...boxMarkdownFields
    }
  }
`;

export default PDADPage;
